export default __webpack_public_path__ + "static/media/logo-tg-24.724d201c.svg";